import MDBox from "components/MDBox";
import DefaultSortInfoCard from "examples/Cards/InfoCards/DefaultInfoCard/DefaultSortInfoCard";
import React from "react";
import { useMaterialUIController } from "context";
import Grid from "@mui/material/Grid";
import { centsToUSD } from "global/functions";
import MDTypography from "components/MDTypography";

const Statistics = ({ type, data }) => {
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;

  const renderCard = (title, icon, key, isCurrency = true) => {
    if (data?.isAll) {
      const parkingVal = data.parking?.[key] || 0;
      const subVal = data.subscription?.[key] || 0;
      const allVal = data.all?.[key] || 0;

      const formatVal = (val) =>
        isCurrency ? centsToUSD(val) : val === 0 ? "0" : val;

      const valueNode = (
        <MDBox display="flex" flexDirection="column" width="100%">
          <MDBox
            display="flex"
            justifyContent="space-between"
            py={0.25}
            width="100%"
          >
            <MDTypography variant="button" color="text" fontWeight="regular">
              Parking
            </MDTypography>
            <MDTypography variant="button" fontWeight="medium" color="dark">
              {formatVal(parkingVal)}
            </MDTypography>
          </MDBox>
          <MDBox
            display="flex"
            justifyContent="space-between"
            py={0.25}
            width="100%"
          >
            <MDTypography variant="button" color="text" fontWeight="regular">
              Subscription
            </MDTypography>
            <MDTypography variant="button" fontWeight="medium" color="dark">
              {formatVal(subVal)}
            </MDTypography>
          </MDBox>
          <MDBox
            display="flex"
            justifyContent="space-between"
            width="100%"
            sx={{
              borderTop: "1px solid rgba(0, 0, 0, 0.08)",
              pt: 0.5,
              mt: 0.5,
            }}
          >
            <MDTypography variant="button" color="dark" fontWeight="bold">
              Total
            </MDTypography>
            <MDTypography variant="button" color="dark" fontWeight="bold">
              {formatVal(allVal)}
            </MDTypography>
          </MDBox>
        </MDBox>
      );

      return (
        <DefaultSortInfoCard
          color={sidenavColor}
          icon={icon}
          title={title}
          value={valueNode}
        />
      );
    } else {
      const val = data?.[key] || 0;
      const formatVal = isCurrency
        ? `${centsToUSD(val)}`
        : val === 0
          ? "0"
          : val;
      return (
        <DefaultSortInfoCard
          color={sidenavColor}
          icon={icon}
          title={title}
          value={formatVal}
        />
      );
    }
  };

  return (
    <>
      <MDBox>
        <Grid container alignItems="center" spacing={2}>
          <Grid item md={4} sm={6} xs={12}>
            {renderCard("Total Revenue", "book_online", "totalRevenue", true)}
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            {renderCard(
              "Total State Tax",
              "real_estate_agent",
              "totalTax",
              true,
            )}
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            {renderCard(
              "Total City Tax",
              "real_estate_agent",
              "totalCityTax",
              true,
            )}
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            {renderCard(
              "Total County Tax",
              "real_estate_agent",
              "totalCountyTax",
              true,
            )}
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            {renderCard(
              "Service Fee",
              "settings_account_box",
              "totalServiceFee",
              true,
            )}
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            {renderCard(
              "Payment Gateway Fee",
              "settings_account_box",
              "totalPaymentGatewayFee",
              true,
            )}
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            {renderCard(
              "Owner Payout",
              "book_online",
              "totalOwnerPayout",
              true,
            )}
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            {renderCard(
              "Client Payout",
              "book_online",
              "totalPrimaryConnectAccountPayout",
              true,
            )}
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            {renderCard(
              "Operator Payout",
              "book_online",
              "totalSecondaryConnectAccountPayout",
              true,
            )}
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            {renderCard(
              "Dock Revenue",
              "book_online",
              "totalDockRevenue",
              true,
            )}
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            {renderCard("Total Refunds", "book_online", "totalRefunds", true)}
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            {renderCard(
              "Pending Payments",
              "book_online",
              "totalPendingPayments",
              true,
            )}
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            {renderCard(
              "Failed Payments",
              "book_online",
              "totalFailedPayments",
              true,
            )}
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            {renderCard(
              "Total Reservations",
              "book_online",
              "totalReservations",
              false,
            )}
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            {renderCard("Total Paid", "real_estate_agent", "totalPaid", false)}
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            {renderCard(
              "Total Failed",
              "real_estate_agent",
              "totalFailed",
              false,
            )}
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            {renderCard(
              "Total Refunded",
              "settings_account_box",
              "totalRefunded",
              false,
            )}
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            {renderCard(
              "Total Validations",
              "settings_account_box",
              "totalValidations",
              false,
            )}
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            {renderCard(
              "Total Free Parking",
              "settings_account_box",
              "totalFree",
              false,
            )}
          </Grid>
        </Grid>
      </MDBox>
    </>
  );
};

export default Statistics;
